import { Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import React from 'react';
import Scriba from 'react-scriba';
import { DataLot } from '../../data/DataLot';
import { DataLotCommercial } from '../../data/DataLotCommercial.jsx';
import { DataOperation } from '../../data/DataOperation';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxTVATaux } from '../ComboBox/ComboBoxTVATaux';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

var objetState = {
    listLotCommercialTVACas: [],
    lotCommercial: {},
    onDesactivePrixMaitrise: false,
    operation: {},
    reservation: {},
    titrePanel: '',

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',
    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',
    onActiveBoutonEnregistrer: false,
};

export class FicheGrilleDePrix_LotCommercial extends React.Component {

    static defaultProps = {
        actionAssociation: undefined, // Nouveau ou Existant
        idLotCommercial: undefined,
        listeLots: [],
        onAffichePanelGrilleDePrix_LotCommercial: false,
        onCacheDialogAssocierLot: () => null,
        onFermeFicheGrilleDePrix_LotCommercial: () => null,
        statut: undefined, // Validé ou Réservé
    };

    _creationContent = () => {

        const { idLotCommercial } = this.props;
        const { listLotCommercialTVACas, lotCommercial, operation } = this.state;

        return <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-lg6">
                    <EUITextField
                        disabled
                        label="ID"
                        value={idLotCommercial}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg6" name="divNumero">
                    <EUITextField
                        label="Numéro"
                        maxLength={MaxLengths.lotCommercial.numero}
                        onDelayedChange={(value, newValue) => this._updateLotCommercial({ numero: newValue })}
                        required
                        value={lotCommercial.numero}
                    />
                </div>
            </div>
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                    <TextField // Note KP : TextFieldNombre en cours de test
                        label="Prix HT"
                        value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'lotCommercial', 'prixHT', false, 2)}
                        onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'lotCommercial', 'prixHT')}
                        onBlur={e => this._calculPrixTTC(e.target.value)}
                        onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'prixHT', e, false, 2)}
                        deferredValidationTime={0}
                        suffix="€"
                        disabled
                    />
                </div>
            </div>
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12" name="divPrixMaitriseHT">
                    <TextField // Note KP : TextFieldNombre en cours de test
                        label="Prix maîtrisé HT"
                        value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'lotCommercial', 'prixMaitriseHT', false, 2)}
                        onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'lotCommercial', 'prixMaitriseHT')}
                        onBlur={e => this._onMiseAJourChampNombre("lotCommercial", "prixMaitriseHT", e.target.value)}
                        onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'prixMaitriseHT', e, false, 2)}
                        deferredValidationTime={0}
                        suffix="€"
                        disabled={this.state.onDesactivePrixMaitrise}
                    />
                </div>
            </div>
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                    <TextField // Note KP : TextFieldNombre en cours de test
                        label="Prix TTC"
                        value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'lotCommercial', 'prixTTC', false, 2)}
                        onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'lotCommercial', 'prixTTC')}
                        onBlur={e => this._calculPrixHT(e.target.value)}
                        onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'prixTTC', e, false, 2)}
                        deferredValidationTime={0}
                        suffix="€"
                        disabled
                    />
                </div>
            </div>
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-lg6" name="divMiseEnVente">
                    <Toggle
                        name="toggleMiseEnVente"
                        label="Mise à la vente"
                        disabled={(this.props.statut === 'Validé' || this.props.statut === 'Réservé')}
                        onText="Oui"
                        offText="Non"
                        onChange={(e, checked) => this._updateLotCommercial({ actifVente: checked })}
                        checked={(this.props.statut === 'Validé' || this.props.statut === 'Réservé') ? true : lotCommercial.actifVente}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg6">
                    <Toggle
                        label="Vente en bloc"
                        disabled={(this.props.statut === 'Validé' || this.props.statut === 'Réservé')}
                        onText="Oui"
                        offText="Non"
                        onChange={(e, checked) => this._updateLotCommercial({ venteEnBloc: checked || null })} // KP (08/09/2020) : remplacer false par null (ticket 1128)
                        checked={lotCommercial.venteEnBloc}
                    />
                </div>
            </div>
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                    <ComboBoxTVATaux
                        name="comboTVATaux"
                        idOperation={operation.idOperation}
                        itemDisabled={!!this.state.reservation // Si le lot est associé à une réservation, griser la TVA utilisée dans la réservation
                            ? tva => tva.idTVACas == this.state.reservation.idTVACas
                            : undefined
                        }
                        multiSelect
                        onChange={(event, option, _, value, item) => {
                            const index = listLotCommercialTVACas.findIndex(tva => tva.idTVACas === option.key);
                            let newListLotCommercialTVACas = [...listLotCommercialTVACas];

                            if (option.selected && index === -1) { // Ajout
                                const { idOperation } = operation;
                                const ordre = newListLotCommercialTVACas.length + 1;
                                newListLotCommercialTVACas.push({ ...item, idOperation, idLotCommercial, ordre });
                            }

                            else { // Suppression
                                const tvaSupprimee = newListLotCommercialTVACas.splice(index, 1)[0];
                                newListLotCommercialTVACas = newListLotCommercialTVACas.map(tva => {
                                    if (tva.ordre <= tvaSupprimee.ordre) return tva;
                                    else return { ...tva, ordre: tva.ordre - 1 };
                                });
                            }

                            this.setState({ listLotCommercialTVACas: newListLotCommercialTVACas }, this._calculPrixTTC)
                        }}
                        onClickDown={newSelectedKey => this.setState({ listLotCommercialTVACas: newSelectedKey }, this._calculPrixTTC)}
                        onClickUp={newSelectedKey => this.setState({ listLotCommercialTVACas: newSelectedKey }, this._calculPrixTTC)}
                        onLoad={!idLotCommercial ? (selectedItems, items) => this.setState({ listLotCommercialTVACas: items }) : null} // Si création, cocher toutes les TVAs disponibles
                        required
                        selectedKey={listLotCommercialTVACas}
                    />
                </div>
            </div>
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                    <div className="ms-Grid my-1" dir="ltr">
                        {!!listLotCommercialTVACas && Array.isArray(listLotCommercialTVACas) &&
                            listLotCommercialTVACas.map((lotCommercialTVACas, index) =>
                                <div key={index} className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm4">{index === 0 ? "Choix principal :" : `${index + 1}ème choix :`}</div>
                                    <div className="ms-Grid-col ms-sm8">{lotCommercialTVACas.tvaCas}</div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>;
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheGrilleDePrix_LotCommercial();
    }

    _onMiseAJourChampNombre = (nomObjet, nomPropriete, valeur) => {
        // KP - 02/03/2023 - 2324 - Méthode obsolète, ne prend pas en charge les callback
        // Sera corrigé / embarqué prochainement dans EUINumericField
        // Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, nomObjet, nomPropriete, valeur)

        console.log("_onMiseAJourChampNombre")

        valeur = valeur
            .replace(/ /g, "")
            .replace(/ /g, "") //Char special (non c'est pas le même ;p)
            .replace(',', '.');

        if (valeur === "") valeur = null;

        let objet = { ...this.state[nomObjet] };
        objet[nomPropriete] = valeur;
        this.setState({ [nomObjet]: objet }, this._onVerificationFormulaire);

        if (this.props.onAffichageSansPanel) {
            this.props.onChange(nomPropriete, valeur);
        }
    };

    _chargementDonnees = () => {

        const { idLotCommercial } = this.props;

        if (idLotCommercial > 0) {
            this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: "Chargement du lot commercial" });

            var chargementLotCommercial = DataLotCommercial._chargementLotCommercialById(idLotCommercial);

            chargementLotCommercial
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        const objetData = responseFetch.reponseAPIobjet;
                        const operation = objetData[0];
                        const listLotCommercialTVACas = objetData[2];
                        const reservation = objetData[3];

                        let lotCommercial = objetData[1];
                        lotCommercial.prixHT = parseFloat(lotCommercial.prixHT).toFixed(2);
                        if (lotCommercial.prixMaitriseHT !== null) {
                            lotCommercial.prixMaitriseHT = parseFloat(lotCommercial.prixMaitriseHT).toFixed(2);
                        }

                        const state = {
                            listLotCommercialTVACas,
                            lotCommercial,
                            onDesactivePrixMaitrise: operation.idPrixMaitrise !== 3,
                            operation,
                            reservation,
                            titrePanel: 'Editer le lot commercial',
                        };

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._calculPrixTTC);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                    }
                });
        }
    }

    _chargementDonnees_Association = () => {

        const { listeLots } = this.props;

        this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: "Chargement du lot commercial" });

        DataOperation._getOperation().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const operation = objetData[0];

                let prixHTCumul = 0.00;
                let prixMaitriseHTCumul = 0.00;

                for (var i = 0; i < listeLots.length; i++) {
                    prixHTCumul += listeLots[i].prixHT;
                    prixMaitriseHTCumul += listeLots[i].prixMaitriseHT;
                }

                const lotCommercial = {
                    ...this.state.lotCommercial,
                    prixHT: prixHTCumul.toFixed(2),
                    prixMaitriseHT: prixMaitriseHTCumul.toFixed(2)
                };

                const state = {
                    listLotCommercialTVACas: [],
                    lotCommercial,
                    onDesactivePrixMaitrise: operation.idPrixMaitrise !== 3,
                    operation,
                    titrePanel: 'Créer un lot commercial',
                };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._calculPrixTTC);
            }
            else {
                Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            }
        });
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du lot commercial en cours'
        });

        const { lotCommercial, listLotCommercialTVACas } = this.state;
        DataLotCommercial._onEnregistrementLotCommercial({ ...lotCommercial, listLotCommercialTVACas }).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {});
                this.props.onFermeFicheGrilleDePrix_LotCommercial();
            }
            else {
                Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            }
        });
    };

    _onAssociationLots = () => {

        const { actionAssociation, listeLots, onCacheDialogAssocierLot, onFermeFicheGrilleDePrix_LotCommercial } = this.props;
        const { lotCommercial, listLotCommercialTVACas } = this.state;

        const fetchMethod = actionAssociation === "Nouveau"
            ? () => DataLot._onAssociationLots_Creation(listeLots, lotCommercial, listLotCommercialTVACas)
            : () => DataLot._onAssociationLots_Modification(listeLots, lotCommercial, listLotCommercialTVACas)
            ;

        const messageEnCoursTraitement = actionAssociation === "Nouveau"
            ? "Association des lots à un nouveau lot commercial"
            : "Association des lots à un lot commercial existant"
            ;

        this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement });

        fetchMethod().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {});
                onFermeFicheGrilleDePrix_LotCommercial();
                onCacheDialogAssocierLot();
            }
            else {
                Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            }
        });

    };

    _calculPrixTTC = (prixHT) => {
        const { listLotCommercialTVACas, lotCommercial } = this.state;
        let newLotCommercial = { ...lotCommercial };
        prixHT = prixHT || lotCommercial.prixHT;

        if (!!listLotCommercialTVACas && Array.isArray(listLotCommercialTVACas) && listLotCommercialTVACas.length > 0) {
            const tvaPrincipale = listLotCommercialTVACas.reduce((prev, current) => prev.ordre < current.ordre ? prev : current);
            const prixTTC = (prixHT * (1 + parseFloat(tvaPrincipale.taux))).toFixed(2);
            newLotCommercial.prixTTC = prixTTC;
        }
        else newLotCommercial.prixTTC = null;

        this.setState({ lotCommercial: newLotCommercial }, () => {
            Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'lotCommercial', 'prixHT', prixHT);
            this._onVerificationFormulaire();
        });
    };

    _calculPrixHT = (prixTTC) => {
        const { listLotCommercialTVACas, lotCommercial } = this.state;
        let newLotCommercial = { ...lotCommercial };
        prixTTC = prixTTC || lotCommercial.prixTTC;

        if (!!listLotCommercialTVACas && Array.isArray(listLotCommercialTVACas) && listLotCommercialTVACas.length > 0) {
            const tvaPrincipale = listLotCommercialTVACas.reduce((prev, current) => prev.ordre < current.ordre ? prev : current);
            const prixHT = (prixTTC / (1 + parseFloat(tvaPrincipale.taux))).toFixed(2);
            newLotCommercial.prixHT = prixHT;
        }

        this.setState({ lotCommercial: newLotCommercial }, () => {
            Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'lotCommercial', 'prixTTC', prixTTC);
            this._onVerificationFormulaire();
        });
    };

    _onRenderFooterContent = () => {
        const { onActiveBoutonEnregistrer } = this.state;
        const onClick = this.props.actionAssociation === 'Nouveau' || this.props.actionAssociation === 'Existant' ? this._onAssociationLots : this._onEnregistrement;

        return <div>
            <PrimaryButton name="btnEnregistrerAssociation" onClick={onClick} disabled={!onActiveBoutonEnregistrer}>Enregistrer</PrimaryButton>
            <DefaultButton onClick={this._onAnnulation}>Fermer</DefaultButton>
        </div>;
    };

    _onOpen = () => {
        if (this.props.actionAssociation === 'Nouveau') {
            this._chargementDonnees_Association();
        }
        else {
            this._chargementDonnees();
        }
    };

    // KP - 29/11/2022 - Méthode _onVerificationFormulaire ajoutée à la classe dans le cadre de la TVA au lot
    _onVerificationFormulaire = () => {
        const { idLotCommercial } = this.props;
        const { lotCommercial, listLotCommercialTVACas } = this.state;
        Immocom.fiche()._validationFormulaire(this, "LotCommercial", { ...lotCommercial, listLotCommercialTVACas }, !idLotCommercial ? "Création" : "Modification");
    };

    _updateLotCommercial = (values) => {
        const lotCommercial = { ...this.state.lotCommercial, ...values };
        this.setState(
            { lotCommercial },
            this._onVerificationFormulaire
        );
    };

    render = () => {
        return <Panel
            isOpen={this.props.onAffichePanelGrilleDePrix_LotCommercial}
            headerText={this.state.titrePanel}
            type={PanelType.medium}
            onDismiss={() => this._onAnnulation()}
            onOpen={() => this._onOpen()}
            closeButtonAriaLabel="Fermer"
            onRenderFooterContent={this._onRenderFooterContent}
        >
            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            {this._creationContent()}

        </Panel>;
    }
}
